import React from 'react'
import FilterReset from '../Includes/Filter/FilterReset'
import ButtonFilter from '../Includes/Button/ButtonFilter'
import IndemnitesToolbarContent from './IndemnitesToolbarContent'
import {
  useSelector
} from 'react-redux'
import {
  isDifferent
} from '../../Functions/Compare'
import {
  filtres
} from '../../Variables/Variables'

const IndemnitesToolbarMobile = ({
  setPage,
  setFilter
}) => {
  const filters = useSelector(state => state.filters.pages)
  const indemnites = useSelector(state => state.indemnites.indemnites)
  const notification = useSelector(state => state.notifications.notification)
  return (
    <div className="toolbar-actions-mobile">
      <IndemnitesToolbarContent/>
      {
        (indemnites.length > 0)
          ? (notification === '')
            ? <ButtonFilter
                onClick={() => setFilter(true)}
              />
            : <FilterReset notification={true}/>
          : null
      }
      {
        (isDifferent([filters.indemnites], [filtres.indemnites]))
          ? <FilterReset
              target="indemnites"
              callback={() => setPage(0)}
            />
          : null
      }
    </div>
  )
}

export default IndemnitesToolbarMobile
